import {
  collection,
  getDocs,
  writeBatch,
  doc
} from "firebase/firestore";

import { db } from "../firebase";

const COLLECTIONS_TO_MIGRATE = [

  "material_requests",

  "purchase_requests",

  "grn",

  "material_returns",

  "defective_returns",

  "inventory_transactions"
];

const buildItemMigrationMap =
  async () => {

    const snap =
  await getDocs(
    collection(db, "items")
  );

    const map = {};

    snap.docs.forEach((d) => {

      const data = d.data();

      const legacyIds = [

        data.id,

        data.firestore_id,

        data.old_item_id,

        d.id
      ];

      legacyIds.forEach((legacyId) => {

        if (
          legacyId &&
          String(legacyId).startsWith("ITEM-") === false
        ) {

          map[
            String(legacyId).trim()
          ] = {

            item_id:
              data.item_id,

            item_code:
              data.item_code,

            item_name:
              data.item_name
          };
        }
      });
    });

    return map;
  };

const migrateItemsArray =
  (
    items = [],
    itemMap = {}
  ) => {

    return items.map((item) => {

      const oldId =
        String(
          item.item_id || ""
        ).trim();

      if (
        oldId.startsWith("ITEM-")
      ) {

        return item;
      }

      const migrated =
        itemMap[oldId];

      if (!migrated) {

        console.warn(
          "NO MATCH:",
          oldId
        );

        return item;
      }

      console.log(
        "MIGRATED:",
        oldId,
        "->",
        migrated.item_id
      );

      return {

        ...item,

        item_id:
          migrated.item_id,

        item_code:
          migrated.item_code,

        item_name:
          migrated.item_name
      };
    });
  };

export const migrateLegacyItemIds =
  async () => {

    try {

      const itemMap =
        await buildItemMigrationMap();

      for (const collectionName of COLLECTIONS_TO_MIGRATE) {

        const snap =
          await getDocs(
            collection(
              db,
              collectionName
            )
          );

        const batch =
          writeBatch(db);

        let updateCount = 0;

        snap.docs.forEach((d) => {

          const data =
            d.data();

          if (
            Array.isArray(
              data.items
            )
          ) {

            const migratedItems =
  migrateItemsArray(
    data.items,
    itemMap
  );

const hasChanges =
  JSON.stringify(migratedItems)
  !==
  JSON.stringify(data.items);

if (!hasChanges) {
  return;
}

batch.update(

              doc(
                db,
                collectionName,
                d.id
              ),

              {
                items:
                  migratedItems
              }
            );

            updateCount++;
          }
        });

        if (updateCount > 0) {

          await batch.commit();
        }

        console.log(
          collectionName,
          updateCount
        );
      }

      alert(
        "Migration Complete"
      );

    } catch (error) {

      console.error(error);

      alert(
        "Migration Failed"
      );
    }
  };